var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 103 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.3542 2.52148H9.61599C5.69672 2.52148 2.51953 5.70036 2.51953 9.62169V73.3497C2.51953 77.271 5.69672 80.4499 9.61599 80.4499H93.3542C97.2734 80.4499 100.451 77.271 100.451 73.3497V9.62169C100.451 5.70036 97.2734 2.52148 93.3542 2.52148Z",
    stroke: "#DB0011",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.54883 73.8722L28.2988 50.1083C29.5733 48.949 31.514 49.036 32.6726 50.2821L39.798 58.1648C41.0145 59.4979 43.129 59.4979 44.3455 58.1648L67.0542 33.4155C68.2417 32.1404 70.2693 32.0824 71.5148 33.3286L100.451 62.4249",
    stroke: "#DB0011",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.373 33.6762C29.7082 33.6762 33.2225 30.1599 33.2225 25.8225C33.2225 21.485 29.7082 17.9688 25.373 17.9688C21.0378 17.9688 17.5234 21.485 17.5234 25.8225C17.5234 30.1599 21.0378 33.6762 25.373 33.6762Z",
    stroke: "#DB0011",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.b8a2ffc00cb0f0ba0914b30b033c8472.svg";
export { ForwardRef as ReactComponent };